export class PlannedOutagesResponse {
    resultCount: number;
    offset: number;
    limit: number;
    sortBy: string;
    sortOrder: string;
    results?: (PlannedOutagesBasicInfo)[] | null;
}

export class PlannedOutagesBasicInfo {
    plannedOutageId: number;
    startDate: string;
    endDate: string;
    itemNames: Array<string>;
    reason: string;
}
